export default "<p>\r\n  no-internet works!\r\n</p>\r\n"